
import React from 'react';
import Router from './Router';

import Footer from './pages/common/Layout/Footer';
import Header from './pages/common/Layout/Header';
import LeftSidebar from './pages/common/Layout/LeftSidebar';


function App() {

  //30분동안 움직이 없으면 자동 로그아웃
  var timeCheck_30 = null;
  ['click', 'keydown', 'dragstart', 'dragend'].forEach(function (name) {
    window.addEventListener(name, function (ev) {
        timeCheck()
    });
  });

  function timeCheck() {
    window.clearTimeout(timeCheck_30);
    var countUp = function() {
      sessionStorage.removeItem("loginToken");
        window.alert("세션이 만료되었습니다. \n다시 로그인 해 주시기 바랍니다.");
        window.location = '/signin'; 
        
    };
    timeCheck_30 = window.setTimeout(countUp, 1000 * 60 * 30);
  }

  // 현재 주소값을 읽어와서 레이아웃을 세팅
  const curUrl = window.location.href;
  let layoutONE = true;
  if(curUrl.indexOf('sign') > 0 || curUrl.indexOf('viewer') > 0 ) layoutONE = true; // 1layout일때 ex.로그인화면과 콘텐츠 미리보기 화면.
  else layoutONE = false; // 4layout일때

  return (
    <div className="wrapper">
      {/* layoutONE이 true일때는 레이아웃이 통으로 하나인 페이지. ex.로그인 관련 페이지들 */}
      { !layoutONE && <Header/> }
      
      <Router/>

      { !layoutONE && <LeftSidebar/> }
      { !layoutONE && <Footer/> }
      
    </div>
  );
}

export default App;
